import { SlicePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Story } from '@pyg-services/blog/blog.types';

@Component({
  selector: 'app-blog-item',
  templateUrl: './blog-item.component.html',
  styleUrls: ['./blog-item.component.scss'],
  imports: [RouterLink, SlicePipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogItemComponent {
  public readonly data = input.required<Story>();
  private readonly hasRouteActiveParam =
    !!inject(ActivatedRoute).snapshot.params.article;

  public readonly url = computed(
    () => `${this.hasRouteActiveParam ? '../' : ''}${this.data().slug}`,
  );
}
